import { Component, Optional } from '@angular/core';
import { MatDialogRef, MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { NgTemplateOutlet } from '@angular/common';
import { ResolutionDirective } from '@directives/resolution.directive';
import { IonFooter, IonHeader, IonTitle, IonToolbar } from '@ionic/angular/standalone';

export const NEW_VERSION_DIALOG_WITH = '600px';

@Component({
    templateUrl: 'new-version-dialog.component.html',
    styleUrls: ['new-version-dialog.component.scss'],
    imports: [ResolutionDirective, MatDialogModule, NgTemplateOutlet, MatButtonModule, IonHeader, IonTitle, IonToolbar, IonFooter]
})
export class NewVersionDialogComponent {
  constructor(@Optional() private readonly dialogRef: MatDialogRef<NewVersionDialogComponent>) {}

  reload() {
    window.location.reload();
  }
}
